import React from 'react';
import styled from 'styled-components';
import { useStoreState } from '../store';

export function VideoFrameOverlay() {
  const videoFrameOverlay = useStoreState(s => s.player.videoFrame);
  const ignoreVideoEvents = useStoreState(s => s.player.ignoreVideoEvents);

  return (
    <VideoFrameElement
      style={{ visibility: ignoreVideoEvents ? 'visible' : 'hidden' }}
      poster={videoFrameOverlay || ''}
    />
  );
}

const VideoFrameElement = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
`;
